class PcsHeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('[data-pcs-hero-track]');
    this.slides = Array.from(this.querySelectorAll('[data-pcs-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-pcs-hero-dot]'));
    this.currentIndex = 0;
    this.timer = null;

    if (!this.scroller || this.slides.length < 2) return;

    this.querySelector('[data-pcs-hero-previous]')?.addEventListener('click', () => this.select(this.currentIndex - 1));
    this.querySelector('[data-pcs-hero-next]')?.addEventListener('click', () => this.select(this.currentIndex + 1));
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.select(index)));
    this.scroller.addEventListener('scroll', () => this.handleScroll(), { passive: true });
    this.addEventListener('pointerenter', () => this.pause());
    this.addEventListener('pointerleave', () => this.play());
    this.addEventListener('focusin', () => this.pause());
    this.addEventListener('focusout', () => this.play());
    document.addEventListener('visibilitychange', this.handleVisibility);
    this.addEventListener('shopify:block:select', this.handleBlockSelect);
    this.update(0);
    this.play();
  }

  disconnectedCallback() {
    this.pause();
    document.removeEventListener('visibilitychange', this.handleVisibility);
    this.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  handleVisibility = () => document.hidden ? this.pause() : this.play();

  handleBlockSelect = (event) => {
    const slide = event.target.closest('[data-pcs-hero-slide]');
    const index = this.slides.indexOf(slide);
    if (index >= 0) this.select(index, false);
  };

  handleScroll() {
    window.clearTimeout(this.scrollTimer);
    this.scrollTimer = window.setTimeout(() => {
      const index = Math.round(this.scroller.scrollLeft / Math.max(this.scroller.clientWidth, 1));
      this.update(Math.min(Math.max(index, 0), this.slides.length - 1));
    }, 80);
  }

  select(index, smooth = true) {
    const nextIndex = (index + this.slides.length) % this.slides.length;
    this.scroller.scrollTo({ left: this.scroller.clientWidth * nextIndex, behavior: smooth ? 'smooth' : 'auto' });
    this.update(nextIndex);
  }

  update(index) {
    this.currentIndex = index;
    this.slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== index)));
    this.dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false'));
  }

  pause() {
    window.clearInterval(this.timer);
    this.timer = null;
  }

  play() {
    this.pause();
    const seconds = Number(this.dataset.autoplaySpeed || 0);
    if (!seconds || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = window.setInterval(() => this.select(this.currentIndex + 1), seconds * 1000);
  }
}

if (!customElements.get('pcs-hero-slideshow')) {
  customElements.define('pcs-hero-slideshow', PcsHeroSlideshow);
}
